export const selectChannels = (state) => state.channels;

export const selectChannel = (state, options) => selectChannels(state)[options.id];



// WEBPACK FOOTER //
// ./src/modules/channels/selectors/index.js